import React from "react";

export function RemoveIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 19 24" width="1em" height="1em" {...props}>
      <g fill="currentColor">
        <path d="M14.48 24H4.72C2.8 24 1.2 22.48 1.2 20.56V5.2c0-.24.16-.4.4-.4h16c.24 0 .4.16.4.4v15.36c0 1.92-1.6 3.44-3.52 3.44zM2 5.6v14.96C2 22 3.2 23.2 4.72 23.2h9.76c1.52 0 2.72-1.2 2.72-2.64V5.6H2z" />
        <path d="M8 20.8c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm3.2 0c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm7.2-15.2H.8c-.24 0-.4-.16-.4-.4v-.8c0-1.52 1.28-2.8 2.8-2.8h2.24l.8-.8c.56-.56 1.28-.8 2-.8h2.8c.72 0 1.44.32 2 .8l.8.8H16c1.52 0 2.8 1.28 2.8 2.8v.8c0 .24-.16.4-.4.4zM1.2 4.8H18v-.4c0-1.12-.88-2-2-2h-2.4c-.08 0-.24-.08-.32-.08l-.88-.88c-.32-.4-.88-.64-1.36-.64h-2.8c-.56 0-1.04.24-1.44.56l-.88.88c-.08.08-.24.16-.32.16H3.2c-1.12 0-2 .88-2 2v.4zm3.6 16c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm9.6 0c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4z" />
      </g>
    </svg>
  );
}

export function RepositionIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" width="1em" height="1em" {...props}>
      <path
        fill="currentColor"
        d="M0 44h31v16.586l-5.293-5.293-1.414 1.561 7 7.146h1.414l7-7.146-1.414-1.488L33 60.586V44h31v-2H0zM33 3.414l5.293 5.293 1.414-1.561-7-7.146h-1.414l-7 7.146 1.414 1.488L31 3.414V20H0v2h64v-2H33z"
      />
    </svg>
  );
}

export function CameraIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 20" width="1em" height="1em" {...props}>
      <path
        d="M21.5 20h-19A2.503 2.503 0 0 1 0 17.5v-13C0 3.122 1.122 2 2.5 2h3.789L7.971.163A.496.496 0 0 1 8.339 0h7.321a.5.5 0 0 1 .369.163L17.711 2H21.5C22.878 2 24 3.122 24 4.5v13c0 1.378-1.122 2.5-2.5 2.5zM2.5 3C1.673 3 1 3.673 1 4.5v13c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5h-4.009a.5.5 0 0 1-.369-.163L15.44 1H8.56L6.878 2.837A.5.5 0 0 1 6.509 3H2.5zM12 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-11c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
